import { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { CarouselBlock, BREAKPOINT_LG } from './base';
import SlideableCarouselItem from './slideable-carousel-item';

const MultilayerCarouselBlock = styled(CarouselBlock)`
	grid-gap: 0;
	padding: 20px;
	grid-template-rows: auto;
	cursor: pointer;

	@media (min-width: ${BREAKPOINT_LG}) {
		grid-gap: 5px;
		grid-template-rows: unset;
		align-content: center;
		padding: 40px 55px 80px;
	}
`;

interface Props {
	link?: string;
	externalWindow?: boolean;
	carouselItemClick: (title?: string, id?: number, index?: number, link?: string, externalWindow?: boolean) => void;
	id?: number;
	headerText?: string;
	index?: number;
	children?: ReactNode | ReactNode[];
}

const MultiLayerCarouselItem: FC<Props> = ({
	link = '',
	externalWindow = false,
	carouselItemClick,
	headerText,
	id,
	index,
	children
}) => {
	return (
		<SlideableCarouselItem>
			<MultilayerCarouselBlock
				onTap={() => carouselItemClick(headerText, id, index, link, externalWindow)}
				role="link"
				tabIndex={0}
			>
				{children}
			</MultilayerCarouselBlock>
		</SlideableCarouselItem>
	);
};

export default MultiLayerCarouselItem;
